import {
  City,
  Cliente,
  Country,
  IContratoSimple,
  // IEquipoAdicional,
  IEquipoServicioAdicionales,
  IPaymentMethod,
  IPaymentMethodV2,
  IPromocion,
  IProspectOmitData,
  ISolicitudCanje,
  ISolicitudEvento,
  MotivoRechazo,
  Plan,
  Province,
  SolicitudGremios,
  TipoInstalacion,
} from '..';
import { Empleado } from '../empleados';
import { ITrazabilidad } from '../global/trazabilidad.interface';
import { Zone, Sector, Flota, CoordinateZona } from '../mantenimiento-operaciones';

export interface IFormPreventa {
  direccion: string;
  celular_2: string;
  email_temporal: string;
  email?: string;
  persona_referencia_nombre: string;
  persona_referencia_celular: string;
  persona_referencia_parentesco: string;
  tipo_contrato: string;
  tipo_plan: string;
  tipo_servicio: string;
  es_tercera_edad?: boolean;
  es_discapacitado?: boolean;
  velocidad: string;
  valor_plan: string;
  valor_instalacion: string;
  valor_instalacion_iva: string;
  valor_instalacion_total: string;
  provincia: string;
  ciudad: string;
  zona: string;
  zona_nombre?: string;
  sector: string;
  forma_pago: string;
  plan: string;
  tipo_instalacion: string;
  celular: string;
  prospecto?: string;
  requiere_contrato_fisico?: boolean;
  pre_requiere_contrato_fisico?: boolean;
  pre_autorizacion_sin_ruc?: boolean;
  equipos_adicionales?: IEquipoServicioAdicionales[] | null


  // representante_legal_razon_social?: string | null;
  // representante_legal_identificacion?: string | null;
  // representante_legal_tipo_identificacion?: string | null;
  estado_preventa?: string;

  ///* pymes
  es_pyme?: boolean
  representante_legal_razon_social: string | null;
  representante_legal_identificacion: string;
  representante_legal_tipo_identificacion: string;
  representante_celular1: string;
  representante_celular2: string;
  es_pago_total?: boolean; // es_pago_total
  url_documentos_habilitantes?: string;
  nombre_pyme_enlace?: string
  email_facturacion?: string;
  tipo_contribuyente?: string

  //OPCIONALES
  // codigo?:string;
  plan_referido?: string;
  condicion_residencia?: string;
  observaciones?: any;
  promociones?: any;
  fecha_aceptacion?: string;
  estado_aceptacion?: boolean;
  coordenadas?: string;
  persona_referencia_celular_2?: string;
  tipo_cuenta_bancaria?: string;
  numero_cuenta?: string;
  numero_tarjeta?: string | null;
  url_foto_ruc?: string;
  url_foto_identificacion_delantera?: string;
  url_foto_identificacion_posterior?: string;
  url_foto_aceptacion?: string;
  url_foto_cuenta_bancaria?: string;
  url_foto_tarjeta?: string;
  url_foto_nombramiento?: string;
  url_autorizacion_cargo_tarjeta?: string
  url_autorizacion_debito_automatico?: string
  url_link_firma?: string | null
  no_tramite_firma?: string | null
  codigo_dactilar?: string | null
  mostrar_autorizacion_tarjeta?: boolean
  mostrar_autorizacion_debito?: boolean
  tipo_referido?: string | null;
  entidad_financiera?: string | null;
  cooperativa?: string;
  tarjeta?: string | null;
  tarjeta_fecha_caducidad?: string | null;
  email_referido?: string
  metodo_aceptacion?: string;
  es_router_ac?: boolean;
  requiere_wifi_6?: boolean;
  es_android_tv?: boolean
  numero_cuotas_android_tv?: number
  numero_cantidad_android_tv?: number

  es_ups?: boolean
  numero_cuotas_ups?: number
  numero_cantidad_ups?: number

  require_facturacion?: boolean;
  ruc?: string;
  razon_social_factura?: string;

  referido_flota?: string | null;
  referido_cliente?: string | null;

  //VALORES AXULIARES
  identificacion_factura?: string;
  numero_cuotas_router_ac?: number;
  numero_cuotas_wifi_6?: number;
  servicio_correo: string;
  otro_servicio_correo?: string;

  nombre_refiere?: string | null;
  cedula_refiere?: string | null;
  direccion_refiere?: string | null;
  celular_refiere?: string | null;
  codigo_forma_pago?: string;

  codigo_refiere?: string | null;
  observacion_1?: string;
  observacion_2?: string;
  observacion_3?: string;
  promocion?: string;
  promocion_nombre?: string;
  promocion_2?: string;
  promocion_3?: string;
  latitud?: string;
  longitud?: string;
  unidad?: string;
  fecha_expedicion_cedula?: string;

  provincia_nombre?: string;
  ciudad_nombre?: string;
  no_cobrar?: boolean;
  coordenasArray?: CoordinateZona[] | null;
  numero_cantidad_router_ac?: number;
  numero_cantidad_wifi_6?: number;
  codigo?: string
  identificacion?: string

  aplica_gremios?: boolean
  identificacion_prospecto?: string
  solicitud_canje?: string
  solicitud_evento?: string
  condicion_venta?: string
  estado_referido?: string | null
  //solicitud_aplica_gremios_data?: SolicitudGremios[]

  tipo_autorizacion_buro?: string;
  tipo_autorizacion_debito?: string;

  // V2 - 3 niveles de pago
  tipo_pago_v2?: string;
  forma_pago_v2?: string;
  forma_pago_legacy?: string | null; // Código de FormaPago V1 mapeado desde V2

  referido_empleado?: string | null;
}

export interface IPreventa {
  count: number;
  numero_paginas: number | undefined;
  next: string | undefined;
  num_pages: string | undefined;
  previous: string | undefined;
  data: IDataPreventa[];
}

export interface IDataPreventa {
  id_preventa: string;
  codigo: string;
  numero_referencia: string;
  condicion_residencia: any | null;
  direccion: string;
  celular_2: string;
  email: string;
  persona_referencia_nombre: string;
  persona_referencia_celular: string;
  persona_referencia_celular_2: string;
  persona_referencia_parentesco: string;
  tipo_contrato: string;
  tipo_plan: string;
  tipo_servicio: string;
  velocidad: string;
  valor_plan: string;
  valor_instalacion: string;
  valor_plan_descuento: string;
  valor_plan_iva: string;
  valor_instalacion_descuento: string;
  valor_instalacion_iva: string;
  valor_plan_total: string;
  valor_instalacion_total: string;
  coordenadas: string;
  observaciones: ObservacionesPreventa;
  url_foto_identificacion_delantera: string;
  url_foto_identificacion_posterior: string;
  url_foto_aceptacion: string | null;
  url_foto_cuenta_bancaria: string | null;
  url_foto_tarjeta: string | null;
  url_foto_nombramiento: string | null;
  url_autorizacion_cargo_tarjeta?: string
  url_autorizacion_debito_automatico?: string
  url_link_firma?: string | null
  no_tramite_firma?: string | null
  mostrar_autorizacion_tarjeta?: boolean
  mostrar_autorizacion_debito?: boolean
  url_foto_ruc?: string
  estado_preventa: string;
  metodo_aceptacion: string;
  numero_cuenta: string;
  numero_tarjeta: string | null;
  tipo_cuenta_bancaria: string;
  tipo_referido: string;
  estado_aceptacion: boolean;
  fecha_aceptacion: string | null;
  estado: boolean;
  fecha_creacion: string;
  fecha_modificacion: string;
  cliente: string | null;
  contrato?: string | null;
  prospecto: string | null;
  tipo_instalacion: string;
  entidad_financiera: string | null;
  tarjeta: string | null;
  promociones: string[];
  flota?: string;
  referido_flota?: string | null;
  //equipos_adicionales?: IEquipoAdicional[];
  equipos_adicionales?: IEquipoServicioAdicionales[] | null
  // cliente_data: Cliente;
  errores: string[];
  codigo_dactilar?: string; //valor auxiliar para actualizar documentos por contrato
  estado_validacion: string;
  estado_validacion_exclude: string;
  estado_validacion_in: string;
  require_facturacion: boolean;
  estado_prospecto: string;
  motivo_rechazo: string;
  requiere_contrato_fisico: boolean;
  pre_requiere_contrato_fisico: boolean;
  pre_autorizacion_sin_ruc: boolean;
  referido_cliente?: string
  //tarjeta_fecha_caducidad?: string;
  fecha_aceptacion_referido?: string | null
  nap_data?: {
    distancia: number;
    distancia_polmax: number;
    nombre: string;
  };
  // equipo adicional as boolean ----
  es_router_ac: boolean;
  numero_cuotas_router_ac?: number;
  requiere_wifi_6: boolean;
  numero_cuotas_wifi_6?: number;
  numero_cantidad_router_ac?: number;
  numero_cantidad_wifi_6?: number;
  es_android_tv?: boolean
  numero_cuotas_android_tv?: number
  precio_android_tv?: number
  numero_cantidad_android_tv?: number
  es_ups?: boolean
  numero_cuotas_ups?: number
  precio_ups?: number
  numero_cantidad_ups?: number
  // no eliminar!
  provincia: string;
  ciudad: string;
  zona: string;
  sector: string;
  forma_pago: string;
  plan: string;
  nap: string;
  no_cobrar?: boolean;
  estado_referido?: string;
  revisar_contrato?: boolean;
  os_aceptacion?: string;
  codigo_forma_pago?: string

  ///* pymes
  representante_legal_razon_social: string;
  representante_legal_identificacion: string;
  representante_legal_tipo_identificacion: string;
  representante_celular1: string;
  representante_celular2: string;
  es_pago_total: boolean;
  url_documentos_habilitantes: string;
  nombre_pyme_enlace?: string;
  user_create: string;
  solicitud_evento?: string
  aplica_gremios?: boolean

  ///* fk
  motivo_rechazo_data: MotivoRechazo | null;
  referido_flota_data: Flota | null;
  referido_cliente_data: Cliente | null;
  provincia_data: Province | null;
  ciudad_data: City | null;
  pais_data?: Country;
  // equipos_adicionales?: IEquipoAdicional[];
  parroquia: any | null;
  zona_data: Zone | null;
  sector_data: Sector | null;
  forma_pago_data: IPaymentMethod | null;
  // V2 - 3 niveles de pago
  tipo_pago_v2?: string;
  forma_pago_v2?: string;
  forma_pago_v2_data?: IPaymentMethodV2 | null;
  trazo_venta_data?: ITrazabilidad[];
  plan_data: Plan | null;
  promociones_data: IPromocion[];
  tipo_instalacion_data: TipoInstalacion
  solicitud_evento_data: Omit<ISolicitudEvento, 'factibilidad_data' | 'factibilidad_corporativa_data'>
  solicitud_canje_data: Omit<ISolicitudCanje, 'factibilidad_data' | 'factibilidad_corporativa_data'>
  solicitud_aplica_gremios_data?: SolicitudGremios[]
  prospecto_data: IProspectOmitData;
  contrato_data?: IContratoSimple | null;
  cliente_data: Cliente;
  referido_empleado?:string| null
  referido_empleado_data?: Empleado | null
}
export interface Poligono {
  lat: string
  lng: string
}
export interface PoligonoPreventa {
  latitud: string;
  longitud: string;
  /* poligono: CoordinateZona[] ;
  latitud: string
  longitud:string */
}

export interface IDataPreventaParams extends Partial<IDataPreventa> {
  page?: number;
  page_size?: number;
  fecha_preventa_before?: string | null;
  fecha_preventa_after?: string | null;
  identificacion?: string;
  user_create?: string;
  generar_pdf_contrato?: boolean;
  cambiar_referido?: boolean
}

export type PreventaGenerateContract = {
  generar_pdf_contrato?: boolean;
}

export interface IReferido {
  id: number;
  nombre: string;
}

export interface IDataReferido {
  tipo: string
  nombre: string
  identificacion: string
  contacto: string
}

export interface IFiltrosGenerarExcelPreventa {
  fecha_preventa_after?: string | null;
  fecha_preventa_before: string | null;
  estado?: string | null;
}

export interface IDataEstadosPreventa {
  codigo: number;
  nombre: string;
}

export enum TiposReferidosENUM {
  EMPLEADO = 'EMPLEADO',
  CLIENTE = 'CLIENTE',
  FLOTA = 'FLOTA',
  NA = 'N/A',
}


export type ObservacionesPreventa = {
  observacion_1?: string;
  observacion_2?: string;
  observacion_cancelar?: string;
  observacion_contrato?: string;

  observacion_update_cliente?: string;
};


export interface FormEditPreventa {
  id_preventa: string;
  celular_2: string;
  persona_referencia_celular: string;
  persona_referencia_celular_2: string;
}

export interface FormMotivoRechazoPreventa {
  id_preventa: string;
  motivo_rechazo: string;
  razon_social?: string;
  identificacion?: string;
  observaciones?: ObservacionesPreventa;
  observacion_cancelacion?: string;
}

export interface FormMotivoRechazoPreventaCorporativa {
  id_preventa_corporativa: string;
  motivo_rechazo: string;
  razon_social?: string;
  identificacion?: string;
  observaciones?: ObservacionesPreventa;
  observacion_cancelacion?: string;
}

export enum cuotasEquipoAdicional {
  MAX = 6,
  MIN = 1,
}

export enum CooperativaENUM {
  AUSTRO = 'AUSTRO'
}